<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }}
        {{ userStore.user.lastname }}
        <br />{{ userStore.user.address }}
        <br />{{ userStore.user.city }},
        {{ userStore.user.state }}
        {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditBureau.address_name }} <br />
        {{ creditBureau.street_address }} <br />
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
    </p>
    <div class="page">
        <p class="letter-content">
            The following account you are publishing about me is <strong>[“inaccurate” or “incomplete” or “inaccurate and incomplete”]</strong>
        </p>
        <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record')">
            <p>
                <strong>"{{ creditor.type }}"</strong>with<strong> Reference#: {{ creditor.reference_number }}</strong>.
            </p>
            <p>
                I have validated with the Bankruptcy Court: <strong>"{{ creditor.furnisher_name }}"</strong> that they did
                not report this information to ANY Credit Reporting Agencies or Data Furnisher's.
            </p>
        </template>
        <p>
            <strong>Please see the bankruptcy courts validation letter included on the Enclousers page.</strong>
        </p>
        <p class="letter-content">
            I request that you <strong><u>DELETE</u></strong> the above-listed tradeline and provide me an updated consumer report. Please inform any person
            or entity to whom you have reported this information that it has been deleted from my report.
        </p>
        <p class="letter-content">
            If you determine that the tradeline item is verified, please provide details of your verification method. Specifically,
            please describe the procedure used to verify the accuracy and completeness of such information. I also request a copy of
            all documents you or anyone else created in connection with your processing of this tradeline item; the person’s name,
            address, and telephone number of such furnisher when you initially prepared that report.
        </p>
        <p>
            Enclosed is a copy of ID and bankruptcy Validation Letter.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>
